"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _themes = _interopRequireDefault(require("@superlogica/foundation/themes"));

var _styledComponents = require("styled-components");

var _reset = _interopRequireDefault(require("./reset"));

var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
      theme = _ref.theme;

  if (typeof theme === 'string') {
    theme = _themes.default[theme];
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reset.default, null), /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, children));
};

ThemeProvider.defaultProps = {
  theme: 'superlogica'
};
var _default = ThemeProvider;
exports.default = _default;